import { object, string, TypeOf } from 'zod';

import { customErrorMap } from './registration';

/* ------------------------ ForgotPasswordRequestBody ----------------------- */

export const ForgotPasswordRequestBody = object({
    email: string({ errorMap: customErrorMap }).email(),
});
export type ForgotPasswordRequestBody = TypeOf<
    typeof ForgotPasswordRequestBody
>;

/* ------------------------ ChangePasswordRequestBody ----------------------- */

export const ChangePasswordRequestBody = object({
    existingPassword: string(),
    newPassword: string().min(12),
    confirmPassword: string().min(12),
}).refine(
    ({ newPassword, confirmPassword }) => newPassword === confirmPassword,
    {
        message: 'Passwords do not match',
        path: ['confirmPassword'],
    },
);

export type ChangePasswordRequestBody = TypeOf<
    typeof ChangePasswordRequestBody
>;

/* ---------------------------- ResetPasswordForm --------------------------- */

export const ResetPasswordForm = object({
    confirmPassword: string({ errorMap: customErrorMap }),
    password: string({ errorMap: customErrorMap }).min(12),
}).refine(({ password, confirmPassword }) => password === confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});

export type ResetPasswordForm = TypeOf<typeof ResetPasswordForm>;

/* ---------------------------- ResetPasswordBody --------------------------- */

export const ResetPasswordBody = object({
    key: string({ errorMap: customErrorMap }),
    confirmPassword: string({ errorMap: customErrorMap }),
    password: string({ errorMap: customErrorMap }).min(12),
}).refine(({ password, confirmPassword }) => password === confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});

export type ResetPasswordBody = TypeOf<typeof ResetPasswordBody>;

/* -------------------------- ResetPasswordResponse ------------------------- */

export const ResetPasswordResponse = object({
    refreshToken: string(),
});
export type ResetPasswordResponse = TypeOf<typeof ResetPasswordResponse>;
